import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { FormBuilder, FormGroup, ValidatorFn, Validators, AbstractControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { DataService } from '../../services/context/data.service';
import { RefDataService } from '../../services/context/ref-data.service';

import { Utils } from '../../../utils/utils';
import * as fromModel from '../../services/models';
import { Constant } from '../../../environments/constants';

import { MatDialog } from '@angular/material/dialog';
import { DeleteConfirmationComponent } from '../../context-components/delete-confirmation/delete-confirmation.component';

@Component({
  selector: 'gp-edit-saving',
  templateUrl: './edit-saving.component.html',
  styleUrls: ['./edit-saving.component.scss']
})
export class EditSavingComponent implements OnInit, OnDestroy {

  form: FormGroup;
  mode = "edit";
  validationMsg='';

  income: fromModel.Income;
  planOwner: fromModel.PlanClient;
  planOwners: fromModel.PlanClient[];
  infRate;
  
  startTypes: fromModel.CodeValue[];
  endTypes: fromModel.CodeValue[];
  incomeTypes: fromModel.CodeValue[];
  
  acc;
  savings: fromModel.Saving[];
  clientContrib: fromModel.Saving;
  clientContribLimit: number;
  
  constructor(
    private dataService: DataService,
    private refDataService: RefDataService,
    private readonly fb: FormBuilder,
    private currencyPipe: CurrencyPipe,
    private dialogRef: MatDialogRef<EditSavingComponent>,
    private dialog: MatDialog, 
    @Inject(MAT_DIALOG_DATA) private inputData: any) { 
    this.form = this.fb.group({
        growthType: ['', [Validators.required]],
        growthRate: ['', [Validators.required, Validators.min(0), Validators.max(100)]],
        startType: ['', [Validators.required]],
        startYr: ['', [Validators.required]],
        startAge: ['', [Validators.required]],
        endType: ['', [Validators.required]],
        endYr: ['', [Validators.required]],
        duration: ['', [Validators.required]],
        endAge: ['', [Validators.required]],
        amount: ['', [Validators.required,  Validators.min(0)]]
      }    
    );
  }

  ngOnInit() {       
    this.startTypes = this.refDataService.getPlanningUIRefDataByType(fromModel.PLANNINGUIREFTYPE.StartType);
    this.endTypes = this.refDataService.getPlanningUIRefDataByType(fromModel.PLANNINGUIREFTYPE.EndType);    
    this.infRate = this.refDataService.getKeyValueByCode(fromModel.KEYREF.InflRt);
    this.planOwners = this.dataService.getPlanOwners();
    this.refDataService.getAccRefByAccType
    if(this.inputData.accountId){
      this.acc = this.dataService.getPlanAccountDetailsByAccId(this.inputData.accountId);
      this.savings = this.dataService.getSavingsByAccId(this.inputData.accountId);
      this.clientContrib = this.dataService.getSavingsByAccIdType(this.inputData.accountId, fromModel.SAVINGSTYPE.SC);
      if(!this.clientContrib){
        this.clientContrib = this.prepareSaving(fromModel.SAVINGSTYPE.SC);
      }
      this.mode = "edit"; 
    } else {
      this.mode = "add"; 
    }

    this.form.valueChanges.subscribe(fm=>{
      if(fm.amount){
        this.form.patchValue({amount: this.currencyPipe.transform(Utils.getCurrency(fm.amount), 'USD', 'symbol', '1.0-0')}, {emitEvent: false});
      }
    });

    // if(this.inputData.incomeId){
    //   this.mode = "edit"; 
    //   this.income = this.dataService.getIncomeByIncomeId(this.inputData.incomeId);       
    // } else {
    //   this.mode = "add";       
    //   this.income = this.preparePlanIncome();      
    // } 
    this.setFormValues();
  }




  setFormValues(){
    let gType;    
    let gRate;   
    let startType;
    let startYr;
    let startAge;
    let endType;
    let endYr;
    let duration;
    let endAge;
    let eAmount;
    

    if(this.mode === "add"){
      
    } else {
  
      gType = this.clientContrib.growthType;
      if(gType === fromModel.GROWTHTYPE.MNF){ 
        gRate = this.clientContrib.growthRate;      
      } else {
        gRate = '';
      }

      startType = this.clientContrib.amtPeriod[0].startType;
      if(startType === fromModel.AMOUNTPERIODTYPE.Year){
        startYr = this.clientContrib.amtPeriod[0].startYr;
      } else {
        startYr = '';
      }      
      if(startType === fromModel.AMOUNTPERIODTYPE.Age){
        startAge = this.clientContrib.amtPeriod[0].startAge;
      } else {
        startAge = '';
      }

      endType = this.clientContrib.amtPeriod[0].endType;
      if(endType === fromModel.AMOUNTPERIODTYPE.Year){
        endYr = this.clientContrib.amtPeriod[0].endYr;
      } else {
        endYr = '';
      }      
      if(endType === fromModel.AMOUNTPERIODTYPE.Age){
        endAge = this.clientContrib.amtPeriod[0].endAge;
      } else {
        endAge = '';
      }

      if(endType === fromModel.AMOUNTPERIODTYPE.Duration){
        duration = this.clientContrib.amtPeriod[0].duration;
      } else {
        duration = '';
      }
      
      eAmount = this.clientContrib.amtPeriod[0].amount;
      
      //this.setIncomeType(type);
      this.validateGrowthType(gType);
      this.validateYearType(startType,"start");
      this.validateYearType(endType,"end");
      if(this.acc.CustodianType === fromModel.CUSTODIANTYPE.HypoEA){
        this.validateContributionLimit(this.acc.actTypeCd);
      } else {
        this.validateContributionLimit(this.acc.registrationtype);
      }
      
      
    }

    this.form.setValue({
      
      growthType: gType,
      growthRate: gRate,
      startType: startType,
      startYr: startYr,
      startAge: startAge,
      endType: endType,
      endYr: endYr,
      endAge: endAge,
      duration: duration,
      amount: this.currencyPipe.transform(eAmount, 'USD', 'symbol', '1.0-0')
      
    });
  }

  validateContributionLimit(accType){
    const accTypeRef = this.refDataService.getAccRefByAccType(accType);
    if(accTypeRef && accTypeRef.contributionLimit){
      this.clientContribLimit = accTypeRef.contributionLimit;
      this.setValidators("amount",[Validators.required, Validators.min(0), this.MaxValidator(accTypeRef.contributionLimit)]);      
    } else {
      this.setValidators("amount",[Validators.required, Validators.min(0), this.MaxValidator(fromModel.DEFAULTS.maxContribLimit)]);            
    }

  }

  MaxValidator(limit): ValidatorFn {  
    return (control: AbstractControl): { [key: string]: any } | null =>  
    Utils.getNumber(control.value) <= limit 
            ? null : {value: control.value};
  }

  prepareSaving(savType: fromModel.SAVINGSTYPE) : fromModel.Saving {
    let startYear = new Date().getFullYear();
    //let endYear = startYear + (this.refDataService.getLifeExpectancyForClient(client.age, client.gender, fromModel.HEALTHCONDITION.Average, fromModel.SMOKER.N).endAge - client.age);
    let saving: fromModel.Saving = {
      "savId": Utils.newGuidByType(fromModel.GUIDTYPE.RCMSAV),
      "savType": savType,
      "savDesc": `${this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.Savings, savType).value}`,      
      "actId": this.acc.id,
      "owner": this.acc.LegalEntityID,
      "growthType": fromModel.GROWTHTYPE.INF,
      "growthRate": 0,
      "amtPeriod": [
        {
          "startType": fromModel.AMOUNTPERIODTYPE.Year, //Year, AtRet, Age
          "startYr": startYear,
          "endType": fromModel.AMOUNTPERIODTYPE.AtRet //Year, AtRet, Age, AtEnd          
        }
      ], 
      "isMonthly": false,
      "isIncluded": true
    };
    return saving;
  }

  setIncomeType(incType: fromModel.INCOMETYPE){
    if(incType === fromModel.INCOMETYPE.SS){
      this.form.patchValue({startType: fromModel.AMOUNTPERIODTYPE.Age});
      //this.form.patchValue({startAge: this.refDataService.getKeyValueByCode(fromModel.KEYREF.SSStart)});        
      this.form.patchValue({startAge: fromModel.DEFAULTS.ssStart});     
      this.form.patchValue({endType: fromModel.AMOUNTPERIODTYPE.AtEnd});                
      this.validateYearType(fromModel.AMOUNTPERIODTYPE.Age,"start");
      this.validateYearType(fromModel.AMOUNTPERIODTYPE.AtEnd,"end");
      this.setValidators("startAge",[Validators.required, Validators.min(62), Validators.max(70)]);      
    } else {
      this.form.patchValue({startType: fromModel.AMOUNTPERIODTYPE.Age});        
      this.form.patchValue({startAge: ''});     
      this.form.patchValue({endType: fromModel.AMOUNTPERIODTYPE.AtEnd});        
      this.validateYearType(fromModel.AMOUNTPERIODTYPE.Age,"start");
      this.validateYearType(fromModel.AMOUNTPERIODTYPE.AtEnd,"end");
      this.setValidators("startAge",[Validators.required]);      
    }
  }
    
  selectGrowthType(growthType){
    this.validateGrowthType(growthType);
  }

  selectYearType(event: any, amountPeriodType: fromModel.AMOUNTPERIODTYPE, yearType){     
    if(event.isUserInput){
      this.validateYearType(amountPeriodType,yearType);
    }
  }
 
  clearValidators(field){
    this.form.controls[field].setErrors(null);    
    this.form.controls[field].clearValidators();
    this.form.controls[field].updateValueAndValidity();
  }

  setValidators(field, validators: ValidatorFn[]){
    this.form.controls[field].setValidators(validators);
    this.form.controls[field].updateValueAndValidity();
  }


  validateYearType(amountPeriodType: fromModel.AMOUNTPERIODTYPE, yearType){
    let yrField;
    let ageField;
    let durationField;

    if(yearType === 'start'){
      yrField = "startYr";
      ageField = "startAge";
    } else {
      yrField = "endYr";
      ageField = "endAge";
      durationField = "duration";
    }

    if(amountPeriodType === fromModel.AMOUNTPERIODTYPE.AtRet 
      || amountPeriodType === fromModel.AMOUNTPERIODTYPE.AtEnd){
      this.clearValidators(yrField);
      this.clearValidators(ageField);
      if(durationField){
        this.clearValidators(durationField);        
      }
    } else if(amountPeriodType === fromModel.AMOUNTPERIODTYPE.Duration){
      this.setValidators(durationField, [Validators.required]);
      this.clearValidators(yrField);      
      this.clearValidators(ageField);

    } else if(amountPeriodType === fromModel.AMOUNTPERIODTYPE.Age){
      this.setValidators(ageField, [Validators.required]);
      this.clearValidators(yrField);      
      if(durationField){
        this.clearValidators(durationField);        
      }
    } else if(amountPeriodType === fromModel.AMOUNTPERIODTYPE.Year){
      this.setValidators(yrField, [Validators.required]);
      this.clearValidators(ageField);      
      if(durationField){
        this.clearValidators(durationField);        
      }
    }
  }

  validateDuration(){
    let isValid=true;

    if(this.form.get('startType').value === fromModel.AMOUNTPERIODTYPE.Year
    && this.form.get('endType').value === fromModel.AMOUNTPERIODTYPE.Year)
    {      
      if(Number(this.form.get('startYr').value)>=Number(this.form.get('endYr').value)){
        isValid=false;
        this.validationMsg = Constant.ErrorMsgs.durationErrorMsg;
      }      
    } else if(this.form.get('startType').value === fromModel.AMOUNTPERIODTYPE.Age
    && this.form.get('endType').value === fromModel.AMOUNTPERIODTYPE.Age)
    {      
      if(Number(this.form.get('startAge').value)>=Number(this.form.get('endAge').value)){
        isValid=false;
        this.validationMsg = Constant.ErrorMsgs.durationErrorMsg;
      }      
    }
    return isValid;
  }

  validateGrowthType(growthType){
    if(growthType === fromModel.GROWTHTYPE.INF){
      //this.form.patchValue({growthRate: ''});
      this.clearValidators("growthRate");
    } else {
      this.setValidators("growthRate",[Validators.required]);      
    }
  }

  saveAccountAndSaving(): void {
    if(this.form.valid && this.validateDuration()){
      //console.log(this.form.getRawValue());     
      
      this.clientContrib.growthType = this.form.get('growthType').value;

      if(this.clientContrib.growthType === fromModel.GROWTHTYPE.MNF){
        this.clientContrib.growthRate = this.form.get('growthRate').value;
      }

      this.clientContrib.amtPeriod[0].startType = this.form.get('startType').value;      
      if(this.clientContrib.amtPeriod[0].startType === fromModel.AMOUNTPERIODTYPE.Year){
        this.clientContrib.amtPeriod[0].startYr = this.form.get('startYr').value;        
      } else if(this.clientContrib.amtPeriod[0].startType === fromModel.AMOUNTPERIODTYPE.Age){
        this.clientContrib.amtPeriod[0].startAge = this.form.get('startAge').value;
      }
      
      this.clientContrib.amtPeriod[0].endType = this.form.get('endType').value;
      if(this.clientContrib.amtPeriod[0].endType === fromModel.AMOUNTPERIODTYPE.Year){
        this.clientContrib.amtPeriod[0].endYr = this.form.get('endYr').value;
      } else if(this.clientContrib.amtPeriod[0].endType === fromModel.AMOUNTPERIODTYPE.Age){
        this.clientContrib.amtPeriod[0].endAge = this.form.get('endAge').value; 
      } else if(this.clientContrib.amtPeriod[0].endType === fromModel.AMOUNTPERIODTYPE.Duration){
        this.clientContrib.amtPeriod[0].duration = this.form.get('duration').value; 
      }
      
      this.clientContrib.amtPeriod[0].amount = Utils.getNumber(this.form.get('amount').value);
      
      if(this.mode === "edit"){
        this.dataService.dispatchAction(fromModel.DATA_ACTION.UPDATESAVING, "EditSavingComponent-saveAccountAndSaving-UpdateExistingSaving", [{saving: this.clientContrib}]);
      } else if(this.mode === "add"){ 
        this.dataService.dispatchAction(fromModel.DATA_ACTION.ADDSAVING, "EditSavingComponent-saveAccountAndSaving-CreateNewSaving", [{saving: this.clientContrib}]);
      }
      this.dataService.savePlan();
      this.closeDialog(true);
    } else {
        console.log('There is a problem with the form.');
    }
  }

  deleteIncome(): void {
    this.openModelDialog(fromModel.OPENDIALOGACTIONS.DELETEINCOME);    
  }

  openModelDialog(action: fromModel.OPENDIALOGACTIONS){
    switch(action){
      case fromModel.OPENDIALOGACTIONS.DELETEINCOME: {
        const dialogRef = this.dialog.open(DeleteConfirmationComponent, {
          width: '500px',
          height: '240px',
          data: { deleteType: fromModel.DELETETYPE.Income, name: this.income.incDesc}                  
        }).afterClosed()
        .subscribe(isDeleted => {
          if(isDeleted){
            this.dataService.dispatchAction(fromModel.DATA_ACTION.DELETEINCOME, "EditIncomeComponent-openModelDialog-DeleteIcome", {income: this.income});
            this.dataService.savePlan();
            this.closeDialog(true);
          }
        });
        break;
      }     
    }
  }

  closeDialog(saved: boolean | false): void {
    this.dialogRef.close({isSaved: saved, income: this.income});
  }
  
 
  ngOnDestroy(): void{    
  }
}
